export class ScrollClass {
  constructor() {
    this.element = document.querySelector('header.scroll-up-enabled');
    this.lastScrollTop = 0;
    this.currentScrollTop = 0;
    this.init();
  }

  init() {
    window.addEventListener('scroll', () => {
      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      if(!document.querySelector('.resp-menu-open') && document.querySelector('.search-navigation') && !document.querySelector('.search-navigation').classList.contains('visible')){
        if (this.currentScrollTop > this.lastScrollTop && this.currentScrollTop > 200) {
          this.element.classList.add('scroll-down');
          this.element.classList.remove('scroll-up');
          if(document.querySelector('#login-popup').classList.contains('open')) {
            document.querySelector('.open-login-popup').click();
          }
          
        } else {
          this.element.classList.add('scroll-up');
          this.element.classList.remove('scroll-down');
        }
        this.lastScrollTop = this.currentScrollTop;
      }


    });
  }
}